import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Stack } from '@eds-web/react';
import { TaxProfile } from '../../types/payout.types';

interface PersonalInfoSectionProps {
    taxProfile: TaxProfile;
}

export const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({ taxProfile }) => {
    const { t } = useTranslation();

    return (
        <Stack gap={24}>
            <div className="form-column">
                <TextField
                    label={t('epic.esport.label.profile.firstName')}
                    value={taxProfile?.firstName}
                    placeholder={t('epic.esport.label.profile.firstName')}
                    disabled
                />
                <TextField
                    label={t('epic.esport.label.profile.lastName')}
                    value={taxProfile?.lastName}
                    placeholder={t('epic.esport.label.profile.lastName')}
                    disabled
                />
            </div>
            <div className="form-column">
                {Boolean(taxProfile?.tin) && (
                    <TextField
                        label={t('epic.esport.placeholder.payoutInfo.TAXID')}
                        value={taxProfile?.tin || taxProfile?.foreignTin}
                        placeholder={t('epic.esport.placeholder.payoutInfo.TAXID')}
                        disabled
                    />
                )}
                {Boolean(taxProfile?.foreignTin) && (
                    <TextField
                        label={t('epic.esport.placeholder.payoutInfo.FOREIGN_TAXID')}
                        value={taxProfile?.foreignTin}
                        placeholder={t('epic.esport.placeholder.payoutInfo.FOREIGN_TAXID')}
                        disabled
                    />
                )}
                {Boolean(!taxProfile?.foreignTin && !taxProfile?.tin) && (
                    <div className="empty-class" />
                )}
            </div>
        </Stack>
    );
};
